import { observer } from 'mobx-react-lite';
import React from 'react';
import { InviteEmployersDelegate } from 'store/modules/group/ui-stores/inviteEmployersDelegate';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { Button, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import EmployerBlock from './EmployerBlock';
import {
  EmployersModalStyled,
  EmployersSectionStyled,
  ModalTitleStyled,
  ModalSubtitleStyled,
  NoDataMessageStyled,
  ModalContentWrapperStyled,
  ModalFooterStyled,
} from './styles';
import EmployerForm from './EmployerForm';
import {
  INVITE_EMPLOYER_MODAL_CLOSE_BTN_TEST_ID,
  INVITE_EMPLOYER_MODAL_NO_DATA_MESSAGE_TEST_ID,
  INVITE_EMPLOYER_MODAL_TEST_ID,
  INVITE_EMPLOYER_MODAL_SPINNER_TEST_ID,
} from '../constants';

interface Props {
  inviteEmployersDelegate: InviteEmployersDelegate;
}

// TODO Add logic to update group admin. It is implemented in src/components/group-info/EditEmployersModal/index.tsx
// but should be rethought and updated after the new group profile redesign.
const InviteEmployersModal: React.FC<Props> = observer(({ inviteEmployersDelegate }) => {
  const { employerDelegates, isLoading, closeModal, isVisible } = inviteEmployersDelegate;
  return (
    <EmployersModalStyled show={isVisible} onClose={closeModal} closable data-test-id={INVITE_EMPLOYER_MODAL_TEST_ID}>
      <>
        <ModalTitleStyled>Group Access</ModalTitleStyled>
        <ModalSubtitleStyled>
          Invite users from the group to create an account and access the checklist.
        </ModalSubtitleStyled>
        <ModalContentWrapperStyled>
          {employerDelegates.length > 0 ? (
            <EmployersSectionStyled>
              {employerDelegates.map((employerDelegate) => {
                return (
                  <EmployerBlock
                    key={employerDelegate.employer.id}
                    inviteEmployersDelegate={inviteEmployersDelegate}
                    employerDelegate={employerDelegate}
                    isGroupAdmin={employerDelegate.isAdmin}
                  />
                );
              })}
            </EmployersSectionStyled>
          ) : (
            <NoDataMessageStyled data-test-id={INVITE_EMPLOYER_MODAL_NO_DATA_MESSAGE_TEST_ID}>
              No added group users. Add the first one in the form below.
            </NoDataMessageStyled>
          )}
          <EmployerForm
            formController={inviteEmployersDelegate.addEmployerForm}
            id="add-employer-form"
            actionBtnText="Invite"
            actionBtnIcon={<Add />}
          />
          <OverlaySpinner display={isLoading} data-test-id={INVITE_EMPLOYER_MODAL_SPINNER_TEST_ID} />
        </ModalContentWrapperStyled>
        <ModalFooterStyled>
          <Button
            type="outlined"
            onClick={closeModal}
            size="large"
            data-test-id={INVITE_EMPLOYER_MODAL_CLOSE_BTN_TEST_ID}
          >
            Close
          </Button>
        </ModalFooterStyled>
      </>
    </EmployersModalStyled>
  );
});

export default InviteEmployersModal;
